import { render, staticRenderFns } from "./LegalDocumentContent_Q2UfD4.vue?vue&type=template&id=30cba244&scoped=true&"
var script = {}
import style0 from "./LegalDocumentContent_Q2UfD4.vue?vue&type=style&index=0&id=30cba244&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cba244",
  null
  
)

export default component.exports